const BaseView = require('../components/accordion-list/categories-director');
const SearchView = require('../search/search');
const ModalKwlsLogin = require('../../../modal/kwls-login');

module.exports = BaseView.extend({
  templates: {
    kwls: require('./search-results/kwls.hbs'),
    mns: require('./search-results/mns.hbs')
  },

  events: _.extend({
    'click .search-close': 'closeSearchEvent'
  }, BaseView.prototype.events),

  initialize: function () {
    _.bindAll(this, 'refreshAntiscroll', 'searchCallback', 'addThumbnail', 'mapResult');
    this.server = INKIVE.C.IS_DEV || INKIVE.C.IS_QA
      ? 'https://qa-kong.command-api.kw.com'
      : 'https://kong.command-api.kw.com';
    BaseView.prototype.initialize.call(this);
  },

  onSearch: function () {
    this.$el.find('.search-title').addClass('disabled');
    this.$el.siblings('.search-container').addClass('disabled');
    this.pendingSearchRequest++;
  },

  search: function ($searchInput) {
    const $imageList = this.$el.find('.image-list');
    const $tabContent = $imageList.find('.tab-content');
    this.tool = INKIVE.Tool.getInstance();

    this.$el.find('.search-title').removeClass('hidden');
    $imageList.find('.antiscroll-scrollbar').remove();
    $tabContent.css('height', '').empty().removeData();
    this.$el.find('.search-title').addClass('disabled');
    this.$el.siblings('.search-container').addClass('disabled');
    this.pendingSearchRequest = 0;
    this.$searchOptions.toggle(false);

    this.searchView = this.searchView || new SearchView();
    this.searchView.initSearch($imageList,
      {
        query: $searchInput.val(),
        type: this.type,
        callback: this.refreshAntiscroll,
        url: this.getSearchUrl($searchInput.val()),
        authErrorCallback: () => this.authErrorCallback(),
        skipScrollDetect: this.searchType === 'postal_code'
      },
      this.searchCallback,
      this.onSearch.bind(this)
    );
  },

  searchCallback: function (elems) {
    return _.chain(elems)
      .map(this.mapResult)
      .each(this.addThumbnail);
  },

  closeSearchEvent: function (event) {
    const $searchTitle = $(event.currentTarget).parents('.search-title');
    const searchInput = this.$el.closest('.tab-content').find('.search-container input');

    $searchTitle.addClass('hidden');
    this.$el.find('.tab-content').empty();
    searchInput.val('');
    searchInput.toggleClass('searching');
  },

  refreshAntiscroll: function () {
    if (this.pendingSearchRequest > 1) {
      this.pendingSearchRequest--;
      return;
    }

    this.$el.siblings('.search-container').removeClass('disabled');
    this.$el.find('.search-title').removeClass('disabled');

    if (this.searchType === 'postal_code') {
      return;
    }

    this.$el.find('.antiscroll-wrap').antiscroll({ horizontal: false });
    this.$el.find('.antiscroll-scrollbar').css('left', 304);
    this.pendingSearchRequest--;
  },

  refresh: _.noop,

  addThumbnail: function (item) {
    const template = this.templates[this.type]({
      item,
      longId: item.id && item.id.length > 10
    });

    this.$el.find('.tab-content').append(template);
  },

  authErrorCallback: function () {
    const login = new ModalKwlsLogin({ server: this.server });

    const modal = INKIVE.Modal.modalWindow(login.getFormHtml(), {
      width: 396,
      height: 450,
      headerTitle: 'modal.kwls_login.title',
      buttons: [{
        title: INKIVE.TranslateHelper.translate('modal.buttons.send_request'),
        onClick: () => submitLogin.call(this),
        cls: 'kwls-login-button'
      }]
    });

    function submitLogin () {
      INKIVE.Modal.togglePageLoader(true);
      login.sendRequest((response) => this.loginSuccessfullCallback(modal, response));
    }
  },

  loginSuccessfullCallback: function (modal, response) {
    modal.close();
    INKIVE.Modal.togglePageLoader(false);
    INKIVE.C.USER.kw_sso_token = response.access_token;
    this.search(this.$el.siblings('.search-container').find('[name=search]'));
  }
});
